<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      alerta: state => state.moduleAlerta.alerta,
    }),
  },
  methods:{
    btnSalvarAlterar() {
      this.$store.dispatch("ALTERARALERTA", {
          codOcorrencia: this.alerta.codOcorrencia,
          usuario: this.usuario.codUsuario,
          cidade: this.user.cidade,
          alerta: this.alerta
      }).then((result) => {
        if(result){
          this.$swal.fire({
            title: "Alterar o Alerta",
            text: 'Gravado com Sucesso',
            icon: "success"
          })
          this.$emit('limparCampos')
        }
        else{
          this.$swal.fire({
            title: "Alterar o Alerta",
            text: 'Erro na Tentativa de Alterar o alerta',
            icon: "error"
          })
        }
        }
      )
    },
  }
    
}
</script>

<template>
  <b-button :disabled='!alerta.placaValido && !alerta.placaCompleta' @click='btnSalvarAlterar' :variant="!ativar ? 'warning' : ''">Alterar</b-button>
</template>

<style>

</style>